import React from 'react'

class EnabledTabButtonComponent extends React.Component {
  render () {
    return (
      <div style={styles.buttonContent}>
        <button
          style={styles.button}>
          <span style={styles.label}>{this.props.label}</span>
          <img
            style={styles.icon}
            src={this.props.img}
            alt='true'
          />
        </button>
      </div>
    )
  }
}

const styles = {
  buttonContent: {
    marginTop: '6px',
    float: 'right',
    height: '34px'
  },
  button: {
    cursor: 'pointer',
    marginTop: '4px',
    width: 'auto',
    minWidth: '156px',
    height: '29px',
    marginLeft: '12px',
    border: 'none',
    borderRadius: '10px',
    backgroundColor: '#7ED321',
    outline: 'none'
  },
  label: {
    textAlign: 'center',
    color: '#272D31',
    fontSize: '10px',
    fontWeight: 700
  },
  icon: {
    float: 'right',
    marginLeft: '4px'
  }
}

export default EnabledTabButtonComponent
